import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=01daddaa&scoped=true"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"
import style0 from "./Base.vue?vue&type=style&index=0&id=01daddaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01daddaa",
  null
  
)

export default component.exports